import React, { forwardRef, SVGProps } from 'react';

export type CreateIconOptions = {
  /**
   * @default "24"
   */
  width?: string;
  /**
   * @default "24"
   */
  height?: string;
  /**
   * The icon `svg` viewBox
   * @default "0 0 [width] [height]"
   */
  viewBox?: string;
  /**
   * The `svg` path or group element
   * @type React.ReactElement | React.ReactElement[]
   */
  path?: React.ReactElement | React.ReactElement[];
  /**
   * If the icon only have a single path, simply copy the path's `d` attribute
   */
  d?: string;
  /**
   * The `d` fill attribute, use this if the icon only has a single path
   * @default "currentColor"
   */
  fill?: string;
  /**
   * The `svg` xmlns attribute
   * @default "http://www.w3.org/2000/svg"
   */
  xmlns?: string;
};

export const createIcon = (options: CreateIconOptions) => {
  const {
    d: pathDefinition,
    width = '24',
    height = '24',
    xmlns = 'http://www.w3.org/2000/svg',
    viewBox = `0 0 ${width} ${height}`,
    fill = 'currentColor',
  } = options;

  const path = React.Children.toArray(options.path);

  return forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
    <svg
      ref={ref}
      fill="none"
      width={width}
      height={height}
      viewBox={viewBox}
      xmlns={xmlns}
      {...props}
    >
      {path.length ? path : <path fill={fill} d={pathDefinition} />}
    </svg>
  ));
};
